import { environmentConfig } from "@src/appV2/environment/config";
import { mapLegacyRoute } from "@src/appV2/redesign/PushNotifications/legacyRouteMapper";

const KNOWN_APP_URLS = [
  environmentConfig.REACT_APP_WORKPLACE_APP_URL,
  environmentConfig.REACT_APP_ADMIN_APP_CLIENT_URL,
];

/**
 * Resolve a Braze content card URL for in-app navigation.
 *
 * Braze content cards carry absolute URLs (e.g. https://clipboard.health/shift-details/123).
 * On Capacitor mobile the native origin is capacitor://localhost, so these are
 * misclassified as external by the generic openUrl helper and opened in an in-app
 * browser — which shows a login page because there is no active session there.
 *
 * This function detects URLs from known app domains, extracts the path, and applies
 * legacy route mapping — the same translation that push notifications and deep links
 * already perform.
 */
export function resolveNotificationCardUrl(url: string): string {
  try {
    const parsedUrl = new URL(url);

    const isKnownAppDomain = KNOWN_APP_URLS.some((appUrl) => {
      try {
        return new URL(appUrl).origin === parsedUrl.origin;
      } catch {
        return false;
      }
    });

    if (isKnownAppDomain) {
      const path = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
      const mapped = mapLegacyRoute(path);
      return mapped ?? path;
    }
  } catch {
    // Not a valid absolute URL — return as-is (relative paths, fragments, etc.)
  }

  return url;
}
